import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import { TFunction } from 'i18next';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(weekOfYear);
dayjs.extend(isoWeek); // ISO week: hafta dushanbadan boshlanadi

export function getDateRangeLabel(start: string, end: string, t: TFunction): string {
  const startDate = dayjs(start, 'DD.MM.YYYY');
  const endDate = dayjs(end, 'DD.MM.YYYY');

  const today = dayjs().startOf('day');
  const yesterday = today.subtract(1, 'day');

  const startOfWeek = today.startOf('isoWeek'); // Dushanbadan boshlab
  const endOfWeek = today.endOf('isoWeek');

  const startOfLastWeek = startOfWeek.subtract(1, 'week');
  const endOfLastWeek = endOfWeek.subtract(1, 'week');

  const startOfMonth = today.startOf('month');
  const endOfMonth = today.endOf('month');

  const startOfLastMonth = dayjs().subtract(1, 'month').startOf('month');
  const endOfLastMonth = dayjs().subtract(1, 'month').endOf('month');

  const startOfYear = today.startOf('year');
  const endOfYear = today.endOf('year');

  const startOfLastYear = dayjs().subtract(1, 'year').startOf('year');
  const endOfLastYear = dayjs().subtract(1, 'year').endOf('year');

  if (startDate.isSame(today, 'day') && endDate.isSame(today, 'day')) {
    return t('global.Bugun');
  }

  if (startDate.isSame(yesterday, 'day') && endDate.isSame(yesterday, 'day')) {
    return 'Kecha';
  }

  // Kecha va bugun aralash holati
  if (startDate.isSame(yesterday, 'day') && endDate.isSame(today, 'day')) {
    return t('global.Kecha');
  }

  if (startDate.isSame(startOfWeek, 'day') && endDate.isSame(endOfWeek, 'day')) {
    return t('global.Joriy_hafta');
  }

  if (startDate.isSame(startOfLastWeek, 'day') && endDate.isSame(endOfLastWeek, 'day')) {
    return t('global.Otgan_hafta');
  }

  if (startDate.isSame(startOfMonth, 'day') && endDate.isSame(endOfMonth, 'day')) {
    return t('global.Joriy_oy');
  }

  if (startDate.isSame(startOfLastMonth, 'day') && endDate.isSame(endOfLastMonth, 'day')) {
    return t('global.Otgan_oy');
  }

  if (startDate.isSame(startOfYear, 'day') && endDate.isSame(endOfYear, 'day')) {
    return t('global.Joriy_yil');
  }

  if (startDate.isSame(startOfLastYear, 'day') && endDate.isSame(endOfLastYear, 'day')) {
    return t('global.Otgan_yil');
  }

  return `${startDate.format('DD.MM.YYYY')} – ${endDate.format('DD.MM.YYYY')}`;
}
